/**
 * Client-side password strength check. Mirrors backend
 * UsersBusinessLayer.validatePasswordStrength (at least 8 characters, one
 * uppercase letter, one number) so forms can fail fast; the backend still
 * enforces the rule and its message is shown if the two ever drift apart.
 */

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_REQUIREMENTS_HINT = `At least ${PASSWORD_MIN_LENGTH} characters, with an uppercase letter and a number.`;

/** Returns the first unmet requirement as a user-facing message, or null if the password is acceptable. */
export function getPasswordStrengthError(password: string): string | null {
  if (password.length < PASSWORD_MIN_LENGTH) {
    return `Password must be at least ${PASSWORD_MIN_LENGTH} characters long`;
  }
  if (!/[A-Z]/.test(password)) {
    return 'Password must contain at least one uppercase letter';
  }
  if (!/[0-9]/.test(password)) {
    return 'Password must contain at least one number';
  }
  return null;
}
